/* =============================================
   JHANGO ENHANCED CART DRAWER - Custom Elements
   ============================================= */

/* --- Cart Goals --- */
if (!customElements.get('jhango-cart-goals')) {
  class JhangoCartGoals extends HTMLElement {
    connectedCallback() {
      setTimeout(() => {
        this.animateBar();
        this.initConfetti();
      }, 50);
    }

    animateBar() {
      const track = this.querySelector('.jcd-goals__bar-track');
      if (!track) return;

      const target = parseInt(track.dataset.target, 10) || 0;
      const fill = track.dataset.fill || '#111111';
      const bg = track.dataset.bg || '#e0e0e0';

      /* Start at 0% — all background color */
      track.style.background = 'linear-gradient(to right, ' + fill + ' 0%, ' + bg + ' 0%)';

      /* Animate to target after a frame */
      requestAnimationFrame(function() {
        track.style.background = 'linear-gradient(to right, ' + fill + ' ' + target + '%, ' + bg + ' ' + target + '%)';
      });
    }

    initConfetti() {
      if (this.dataset.showConfetti !== 'true') return;
      if (typeof window.confetti === 'undefined') return;

      const activeGoals = Number(this.dataset.activeGoals) || 0;
      const totalGoals = Number(this.dataset.totalGoals) || 0;
      const trigger = this.dataset.confettiTrigger || 'every';
      const prevGoals = Number(localStorage.getItem('jcd-cart-goal-completed') || 0);

      if (prevGoals !== activeGoals) {
        localStorage.setItem('jcd-cart-goal-completed', activeGoals);
      }

      /* Only fire if goals increased */
      if (activeGoals <= prevGoals || activeGoals === 0) return;

      /* "last" mode: only fire when all goals are completed */
      if (trigger === 'last' && activeGoals < totalGoals) return;

      const area = this.dataset.confettiArea || 'drawer';

      if (area === 'page') {
        /* Full-page confetti — no canvas needed, use global confetti */
        window.confetti({
          particleCount: 400,
          spread: 90,
          zIndex: 9999
        });
      } else {
        /* Drawer-scoped confetti — canvas inside the drawer */
        const container = this.closest('.cart-drawer') || this.closest('cart-drawer') || document.body;
        const canvas = document.createElement('canvas');
        canvas.classList.add('jcd-confetti-canvas');
        container.style.position = container.style.position || 'relative';
        container.insertAdjacentElement('afterbegin', canvas);

        /* Canvas needs explicit pixel dimensions for confetti lib to render into it */
        const rect = container.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;

        const myConfetti = window.confetti.create(canvas, { resize: false });
        myConfetti({
          particleCount: 400,
          spread: 90
        });

        setTimeout(() => {
          canvas.remove();
        }, 4000);
      }
    }
  }

  customElements.define('jhango-cart-goals', JhangoCartGoals);
}

/* --- Cart Upsells (Add to Cart) --- */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.jcd-upsells__add-btn');
  if (!btn || btn.disabled) return;

  e.preventDefault();
  const card = btn.closest('.jcd-upsells__card');
  const variantSelect = card ? card.querySelector('.jcd-upsells__variant-select') : null;
  const variantId = variantSelect ? variantSelect.value : btn.dataset.variantId;

  if (!variantId) return;

  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = '...';

  const body = JSON.stringify({
    items: [{ id: parseInt(variantId), quantity: 1 }],
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: '/cart'
  });

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: body
  })
    .then((r) => r.json())
    .then((data) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data);
      } else {
        window.location.reload();
      }
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = originalText;
    });
});

/* Update upsell price when variant changes — use capture phase
   to stop the event before CartItems.onChange validates it as a qty input */
document.addEventListener('change', function (e) {
  if (!e.target.matches('.jcd-upsells__variant-select')) return;
  e.stopPropagation();

  const card = e.target.closest('.jcd-upsells__card');
  if (!card) return;

  const selected = e.target.options[e.target.selectedIndex];
  const priceEl = card.querySelector('.jcd-upsells__card-price');
  const addBtn = card.querySelector('.jcd-upsells__add-btn');

  if (priceEl && selected.dataset.price) {
    priceEl.innerHTML = selected.dataset.price;
  }
  if (addBtn) {
    addBtn.dataset.variantId = e.target.value;
  }
}, true);

/* --- Shipping Calculator --- */
if (!customElements.get('jhango-shipping-calc')) {
  class JhangoShippingCalc extends HTMLElement {
    connectedCallback() {
      this.countrySelect = this.querySelector('[data-jcd-country]');
      this.provinceSelect = this.querySelector('[data-jcd-province]');
      this.provinceWrap = this.querySelector('.jcd-shipping__province-wrap');
      this.zipInput = this.querySelector('[data-jcd-zip]');
      this.btn = this.querySelector('.jcd-shipping__btn');
      this.btnText = this.querySelector('.jcd-shipping__btn-text');
      this.spinner = this.querySelector('.jcd-shipping__spinner');
      this.results = this.querySelector('.jcd-shipping__results');

      if (this.btn) {
        this.btn.addEventListener('click', this.calculate.bind(this));
      }

      if (this.countrySelect) {
        this.countrySelect.addEventListener('change', () => this.updateProvinces());
      }

      this.loadCountryProvinces();
    }

    loadCountryProvinces() {
      if (!this.countrySelect) return;
      if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
        this.initProvinceSelector();
      } else {
        const script = document.createElement('script');
        script.src = window.Shopify.routes.root + 'services/javascripts/shopify_common.js';
        script.onload = () => {
          if (typeof Shopify !== 'undefined' && Shopify.CountryProvinceSelector) {
            this.initProvinceSelector();
          } else {
            this.updateProvinces();
          }
        };
        document.head.appendChild(script);
      }
    }

    initProvinceSelector() {
      try {
        const countryId = this.countrySelect.id;
        const provinceId = this.provinceSelect.id;
        new Shopify.CountryProvinceSelector(countryId, provinceId, { hideElement: false });
        setTimeout(() => this.updateProvinces(), 100);
      } catch (e) {
        this.updateProvinces();
      }
    }

    updateProvinces() {
      if (!this.provinceSelect || !this.provinceWrap) return;
      const hasOptions = this.provinceSelect.options.length > 1 ||
        (this.provinceSelect.options.length === 1 && this.provinceSelect.options[0].value !== '');
      this.provinceWrap.style.display = hasOptions ? '' : 'none';
    }

    calculate() {
      const country = this.countrySelect ? this.countrySelect.value : '';
      const province = this.provinceSelect ? this.provinceSelect.value : '';
      const zip = this.zipInput ? this.zipInput.value : '';

      if (!country) return;

      this.setLoading(true);
      this.results.style.display = 'none';
      this.results.innerHTML = '';

      const params = new URLSearchParams({
        'shipping_address[country]': country,
        'shipping_address[province]': province,
        'shipping_address[zip]': zip
      });

      fetch(window.Shopify.routes.root + 'cart/prepare_shipping_rates.json?' + params.toString(), {
        method: 'POST'
      })
        .then(() => this.pollRates(params))
        .catch(() => {
          this.showError('Could not calculate shipping rates. Please try again.');
          this.setLoading(false);
        });
    }

    pollRates(params, attempts = 0) {
      if (attempts > 10) {
        this.showError('Shipping calculation timed out. Please try again.');
        this.setLoading(false);
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/async_shipping_rates.json?' + params.toString())
        .then((r) => r.json())
        .then((data) => {
          if (data.shipping_rates) {
            this.showRates(data.shipping_rates);
            this.setLoading(false);
          } else {
            setTimeout(() => this.pollRates(params, attempts + 1), 500);
          }
        })
        .catch(() => {
          setTimeout(() => this.pollRates(params, attempts + 1), 500);
        });
    }

    showRates(rates) {
      this.results.style.display = '';
      if (rates.length === 0) {
        this.results.innerHTML = '<p class="jcd-shipping__no-results">No shipping rates available for this address.</p>';
        return;
      }

      let html = '';
      rates.forEach((rate) => {
        html += '<div class="jcd-shipping__result-item">' +
          '<span class="jcd-shipping__result-name">' + rate.name + '</span>' +
          '<span class="jcd-shipping__result-price">' + rate.price + ' ' + rate.currency + '</span>' +
          '</div>';
      });
      this.results.innerHTML = html;
    }

    showError(msg) {
      this.results.style.display = '';
      this.results.innerHTML = '<p class="jcd-shipping__error">' + msg + '</p>';
    }

    setLoading(loading) {
      if (this.btn) this.btn.disabled = loading;
      if (this.btnText) this.btnText.style.display = loading ? 'none' : '';
      if (this.spinner) this.spinner.style.display = loading ? 'inline-flex' : 'none';
    }
  }

  customElements.define('jhango-shipping-calc', JhangoShippingCalc);
}

/* --- Discount Code --- */
if (!customElements.get('jhango-discount-form')) {
  class JhangoDiscountForm extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.jcd-discount__input');
      this.btn = this.querySelector('.jcd-discount__btn');
      this.btnText = this.querySelector('.jcd-discount__btn-text');
      this.spinner = this.querySelector('.jcd-discount__spinner');
      this.message = this.querySelector('.jcd-discount__message');

      if (this.btn) {
        this.btn.addEventListener('click', this.apply.bind(this));
      }

      if (this.input) {
        this.input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.apply();
          }
        });
      }
    }

    apply() {
      const code = this.input ? this.input.value.trim() : '';
      if (!code) {
        this.showMessage('Please enter a discount code.', 'error');
        return;
      }

      this.setLoading(true);
      this.hideMessage();

      fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
        method: 'GET',
        redirect: 'manual'
      })
        .then(() => {
          this.showMessage('Discount applied! Redirecting to checkout...', 'success');
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 1500);
        })
        .catch(() => {
          this.showMessage('Could not apply discount code. Please try again.', 'error');
          this.setLoading(false);
        });
    }

    showMessage(text, type) {
      if (!this.message) return;
      this.message.style.display = '';
      this.message.textContent = text;
      this.message.className = 'jcd-discount__message jcd-discount__message--' + type;
    }

    hideMessage() {
      if (!this.message) return;
      this.message.style.display = 'none';
    }

    setLoading(loading) {
      if (this.btn) this.btn.disabled = loading;
      if (this.btnText) this.btnText.style.display = loading ? 'none' : '';
      if (this.spinner) this.spinner.style.display = loading ? 'inline-flex' : 'none';
    }
  }

  customElements.define('jhango-discount-form', JhangoDiscountForm);
}
